// src/components/common/Cargando.jsx
// Indicador mientras se descarga una pantalla (React.lazy). `enLinea` = dentro del panel; si no, pantalla completa.
import React from 'react';

export default function Cargando({ enLinea = false }) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex flex-col items-center justify-center gap-3 ${enLinea ? 'py-20' : 'min-h-screen'}`}
      style={enLinea ? undefined : { background: '#0A0A0A' }}
    >
      <div
        className="animate-spin rounded-full"
        style={{ width: 28, height: 28, border: '3px solid rgba(255,255,255,0.15)', borderTopColor: '#ff0000' }}
        aria-hidden="true"
      />
      <span className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>Cargando…</span>
    </div>
  );
}
